let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("bvZPH")).then(() => parcelRequire('2jUeN'));